import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error-next",
  "use": "icon-error-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-error-next\">\n<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#F64963\" />\n<path d=\"M12 14L12 7\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle r=\"1\" transform=\"matrix(1 0 0 -1 12 17)\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol